// JOBE-0044.14: drop-suggestion heuristic.
//
// suggestDrop(activeChips, lastNonEmptyPage) → { chip, count } | null
//
// V1 implementation is client-side, computed against the most recent
// non-empty page the user has seen (`lastNonEmptyPage`). The wire-
// authoritative version (?totals=1, JOBE-0044.15 open item #4) is a
// follow-up; for v1 the heuristic is best-effort.
//
// For each removable chip, re-apply the OTHER chips locally against
// the cached page and count how many rows survive. Return the chip
// whose absence yields the largest non-zero count. If no candidate
// yields a non-zero count, return null (the card surfaces generic copy).

import { matchesAllChips } from './matchesAllChips.js';

export function suggestDrop(activeChips, lastNonEmptyPage) {
  const chips = Array.isArray(activeChips) ? activeChips : [];
  const removable = chips.filter((c) => c && c.kind !== 'scope');
  if (removable.length === 0) return null;
  if (!Array.isArray(lastNonEmptyPage) || lastNonEmptyPage.length === 0) {
    return null;
  }

  const candidates = removable.map((chip) => {
    const others = chips.filter((c) => c !== chip);
    const count = lastNonEmptyPage.filter((row) =>
      matchesAllChips(row, others),
    ).length;
    return { chip, count };
  });

  const best = candidates
    .filter((c) => c.count > 0)
    .sort((a, b) => b.count - a.count)[0];
  return best || null;
}
